import React, { useRef } from 'react';

import classNames from 'classnames/bind';
import style from './SideTooltip.scss';

const cx = classNames.bind(style);

function SideTooltip({ children, tooltipConfig }) {
  const { items } = tooltipConfig;
  const ref = useRef(null);

  const renderBalloon = (title, description, renderAfter) => {
    return (
      <div className={cx('balloon')}>
        <h3 className={cx('balloon-title')}>{title}</h3>
        <p className={cx('balloon-description')}>{description}</p>
        {renderAfter && <div className={cx('balloon-after')}>{renderAfter()}</div>}
      </div>
    );
  };

  return (
    <div className={cx('side-tooltip')} ref={ref}>
      <div className={cx('screen')}>{children}</div>
      <div className={cx('tooltip-container')}>
        {items.map((item, index) => {
          const {
            isActive = true,
            offsetTop,
            title = '',
            description = '',
            render,
            renderAfter,
          } = item;

          return (
            isActive && (
              <div key={index} className={cx('tooltip')} style={{ top: offsetTop ? offsetTop : 0 }}>
                {render && render()}
                {!render && renderBalloon(title, description, renderAfter)}
              </div>
            )
          );
        })}
      </div>
    </div>
  );
}

export default SideTooltip;
